module.exports = __webpack_public_path__ + "static/favicon-ee32d9f0c28f18fe7e41fe86988ee805.ico";